// The trail template's blocks. Each is one part of a trail's own page
// (TrailDetail.vue), so a manager can reorder them, drop one, put a
// Text block between two or lay them out in a Columns block — the page
// every trail gets is built from the template's list instead of being
// one fixed block (WebsitePage::KIND_TRAIL_TEMPLATE).
//
// One component draws every part, so the parts cannot drift apart in
// how they read the trail; these are thin wrappers that name the part.
import { h } from 'vue';
import TrailDetail from '../TrailDetail.vue';
import NetworkDetail from '../NetworkDetail.vue';

export const TRAIL_PARTS = {
    trail_header: 'header',
    trail_map: 'map',
    trail_details: 'details',
    trail_about: 'about',
    trail_weather: 'weather',
    trail_hazards: 'hazards',
    trail_nearby: 'nearby',
};

function partBlock(type, part) {
    return {
        name: `TrailPart_${part}`,
        inheritAttrs: false,
        props: { config: { type: Object, default: () => ({}) } },
        setup(props) {
            return () => h(TrailDetail, { config: props.config, part });
        },
    };
}

export const TRAIL_PART_COMPONENTS = Object.fromEntries(
    Object.entries(TRAIL_PARTS).map(([type, part]) => [type, partBlock(type, part)]),
);

// The network page template's blocks, the same way: one component
// (NetworkDetail.vue) draws every part of a network's page. These also
// pass the site's data through, which the weather part reads.
export const NETWORK_PARTS = {
    network_header: 'header',
    network_map: 'map',
    network_details: 'details',
    network_about: 'about',
    network_trails: 'trails',
    network_weather: 'weather',
    network_trailheads: 'trailheads',
    network_hazards: 'hazards',
    network_others: 'others',
};

function networkPartBlock(part) {
    return {
        name: `NetworkPart_${part}`,
        inheritAttrs: false,
        props: {
            config: { type: Object, default: () => ({}) },
            site_data: { type: Object, default: () => ({}) },
        },
        setup(props) {
            return () => h(NetworkDetail, { config: props.config, site_data: props.site_data, part });
        },
    };
}

export const NETWORK_PART_COMPONENTS = Object.fromEntries(
    Object.entries(NETWORK_PARTS).map(([type, part]) => [type, networkPartBlock(part)]),
);
